import styles from './HeroSection.module.css';
import { StoreBadges } from '../shared/StoreBadges';
import { PhoneMockup } from '../shared/PhoneMockup';
import { GrainOverlay } from '../shared/GrainOverlay';
import heroBanner from '../../assets/images/hero-banner.png';

const hearts = [
  { top: '8%', left: '5%', size: 18, opacity: 0.08, rotate: -15 },
  { top: '15%', left: '80%', size: 24, opacity: 0.06, rotate: 20 },
  { top: '35%', left: '12%', size: 14, opacity: 0.1, rotate: -8 },
  { top: '50%', left: '90%', size: 20, opacity: 0.07, rotate: 30 },
  { top: '65%', left: '3%', size: 22, opacity: 0.05, rotate: -25 },
  { top: '75%', left: '85%', size: 16, opacity: 0.09, rotate: 12 },
  { top: '20%', left: '45%', size: 12, opacity: 0.06, rotate: -5 },
  { top: '85%', left: '50%', size: 18, opacity: 0.07, rotate: 18 },
];

export function HeroSection() {
  return (
    <header className={styles.hero}>
      <GrainOverlay />
      {hearts.map((h, i) => (
        <span
          key={i}
          className={styles.heart}
          aria-hidden="true"
          style={{
            top: h.top,
            left: h.left,
            fontSize: `${h.size}px`,
            opacity: h.opacity,
            transform: `rotate(${h.rotate}deg)`,
          }}
        >
          ♥
        </span>
      ))}

      <div className={styles.inner}>
        <div className={styles.grid}>
          <div className={styles.content}>
            <h1 className={`display ${styles.headline}`}>
              The #1 Couples
              <br />
              Intimacy App
              <br />
              in the World
            </h1>
            <p className={styles.sub}>
              Dares, quizzes &amp; roleplay — built for couples. Free to start.
            </p>
            <StoreBadges className={styles.badges} analyticsLocation="hero" />
            <div className={styles.stats}>
              <span><strong>500k+</strong> playing</span>
              <span className={styles.dot}>·</span>
              <span><strong>4.8★</strong> rated</span>
              <span className={styles.dot}>·</span>
              <span><strong>100%</strong> private</span>
            </div>
          </div>

          <div className={styles.photoWrap}>
            <div className={styles.glow} aria-hidden="true" />
            <img src={heroBanner} alt="Couple enjoying a cozy evening" className={styles.heroImg} />
            <div className={styles.phone}>
              <PhoneMockup scale={0.7} />
            </div>
            <div className={styles.mobilePhone}>
              <PhoneMockup scale={0.5} transformOrigin="top left" />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
